import { render, staticRenderFns } from "./settlement-header.vue?vue&type=template&id=3dd19184&scoped=true"
import script from "./settlement-header.vue?vue&type=script&lang=js"
export * from "./settlement-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd19184",
  null
  
)

export default component.exports